import VasodilatorsNote from "../../../../common/tooltip/medication-review/education/vasodilators-note";
import AceInhibitorsNote from "../../../../common/tooltip/medication-review/education/aceInhibitors-note";
import AngiotensionInhibitorsNote from "../../../../common/tooltip/medication-review/education/angiotension-inhibitors-note";
import BetaBlockerNote from "../../../../common/tooltip/medication-review/education/betaBlocker-note";
import CalciumChannelBlockersNote from "../../../../common/tooltip/medication-review/education/calciumChannel-blockers-note";
import HighRiskNote from "../../../../common/tooltip/medication-review/education/high-risk-note";
import EducationUl from "./education-ul";
import EducationOl from "./education-ol";

export const classificationResultCalculation = (
  frequencyOfSymptoms,
  levelOfSeverity
) => {
  if (
    frequencyOfSymptoms === "lessThanFourWeeks" &&
    levelOfSeverity === "symptomsDoNotInterfereWithActivities"
  ) {
    return "Mild Intermittent";
  } else if (
    frequencyOfSymptoms === "lessThanFourWeeks" &&
    levelOfSeverity === "symptomsInterfereWithActivities"
  ) {
    return "Moderate to Severe Intermittent";
  } else if (
    frequencyOfSymptoms === "moreThanFourWeeks" &&
    levelOfSeverity === "symptomsDoNotInterfereWithActivities"
  ) {
    return "Mild Persistent";
  } else if (
    frequencyOfSymptoms === "moreThanFourWeeks" &&
    levelOfSeverity === "symptomsInterfereWithActivities"
  ) {
    return "Moderate to Severe Persistent";
  }
};

export const goalsData = [
  {
    title: "Relief",
    description: "Provide RELIEF from symptoms to an allergic response.",
  },
  {
    title: "Prevent",
    description: "PREVENT symptoms by avoiding exposure to allergens.",
  },
  {
    title: "Minimize",
    description: "MINIMIZE side effects of treatment for allergic rhinitis.",
  },
  {
    title: "Improve",
    description: "IMPROVE quality of life.",
  },
];

export const nasalDropsData = [
  {
    title: "How Medication Works? ",
    altTitle: "How Medication Works? ",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Provides relief from congestion",
            "Washes out nasal mucus and allergens",
            "Adds moisture & relieves dryness",
            "Helps to prevent nosebleeds ",
          ]}
        />
      </div>
    ),
    type: "ul",
  },
  {
    title: "How to Use the Medication",
    altTitle: "How to Use the Medication",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationOl
          type={type}
          descriptionPoints={[
            "Gently blow your nose to clear mucus",
            "Shake bottle and fill dropper as directed",
            "Put the dropper inside one nostril at a time",
            "Wait 3-5 minutes before blowing your nose",
            "Sniff gently to help the drops reach further",
          ]}
        />
      </div>
    ),
    type: "ol",
  },
  {
    title: "How to Assess for Benefits",
    altTitle: "How to Assess for Benefits",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Less congestion",
            "Less nasal stuffiness ",
            "Feels easier to breathe",
          ]}
        />
      </div>
    ),
    type: "ul",
  },
  {
    title: "How to Manage Side Effects",
    altTitle: "How to Manage Side Effects",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={["Can be used as needed"]}
        />
      </div>
    ),
    type: "ul",
  },
];

export const nasalSprayData = [
  {
    title: "How Medication Works? ",
    altTitle: "How Medication Works? ",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Provides relief from congestion",
            "Washes out nasal mucus and allergens",
            "Adds moisture & relieves dryness",
            "Helps to prevent nosebleeds ",
          ]}
        />
      </div>
    ),
    type: "ul",
  },
  {
    title: "How to Use the Medication",
    altTitle: "How to Use the Medication",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationOl
          type={type}
          descriptionPoints={[
            "Gently blow your nose to clear mucus",
            "Prime before first use or if the spray has not been used for several days",
            "Inhale as you spray straight into each nostril",
            "Wait 3-5 minutes before blowing your nose",
            "Rinse and dry the tip, then cap the bottle",
          ]}
        />
      </div>
    ),
    type: "ol",
  },
  {
    title: "How to Assess for Benefits",
    altTitle: "How to Assess for Benefits",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Less congestion",
            "Less nasal stuffiness ",
            "Feels easier to breathe",
          ]}
        />
      </div>
    ),
    type: "ul",
  },
  {
    title: "How to Manage Side Effects",
    altTitle: "How to Manage Side Effects",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={["Can be used as needed"]}
        />
      </div>
    ),
    type: "ul",
  },
];

export const intranasalCorticosteroidsData = [
  {
    title: "How Medication Works? ",
    altTitle: "How Medication Works? ",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <p className="text-teal-300 font-semibold text-body-md">
          {" "}
          Relieves 4 Symptoms:{" "}
        </p>
        <EducationUl
          type={type}
          descriptionPoints={[
            "Nasal itching",
            "Nasal congestion",
            "Runny nose",
            "Sneezing"
          ]}
        />
        <p className="text-teal-300 italic text-body-sm">
            May help with itchy and watery eyes
          </p>
      </div>
    ),
  },
  {
    title: "How to Use the Medication",
    altTitle: "How to Use the Medication",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationOl
          type={type}
          descriptionPoints={[
            "Use saline spray to clear your nose",
            "Blow your nose to clear your nostrils",
            "Shake and prime the bottle if new or has not been used for more than 7 days",
            "Aim the spray away from the nasal septum",
            "Spray the medicine into one nostril at a time",
          ]}
        />
      </div>
    ),
  },
  {
    title: "How to Assess for Benefits",
    altTitle: "How to Assess for Benefits",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Symptom relief occurs within 1 to 2 days",
            "Full benefits may take up to 2 weeks or more for symptoms to improve",
            "Relieves allergy symptoms",
          ]}
        />
      </div>
    ),
  },
  {
    title: "How to Manage Side Effects",
    altTitle: "How to Manage Side Effects",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-6">
        <div className="flex flex-col space-y-2">
          <p className="text-teal-300 font-semibold text-body-md">
            Possible side effects:
          </p>
          <EducationUl
            type={type}
            descriptionPoints={["nasal irritation, stinging, nose bleeds"]}
          />
        </div>
        <div className="flex flex-col space-y-2">
          <p className="text-teal-300 font-semibold text-body-md">
            Manage nasal irritation by:
          </p>
          <EducationUl
            type={type}
            descriptionPoints={[
              "Trying a different nasal spray or use a moisturizing nasal gel",
            ]}
          />
        </div>
        <div className="flex flex-col space-y-2">
          <p className="text-teal-300 font-semibold text-body-md">
            Manage nosebleeds by:
          </p>
          <EducationUl
            type={type}
            descriptionPoints={[
              "Directing spray away from septum or use a moisturizing nasal gel",
            ]}
          />
        </div>
      </div>
    ),
  },
];

export const oralAntihistamineData = [
  {
    title: "How Medication Works? ",
    altTitle: "How Medication Works? ",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <p className="text-teal-300 font-semibold text-body-md">
          Prevents allergy symptoms:{" "}
        </p>
        <EducationUl
          type={type}
          descriptionPoints={[
            "Sneezing",
            "Runny nose",
            "Itchy eyes or nose",
            "Watery eyes",
          ]}
        />
      </div>
    ),
  },
  {
    title: "How to Use the Medication",
    altTitle: "How to Use the Medication",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Take the medication as prescribed each day",
            "Works best if taken every day at the same time ",
          ]}
        />
      </div>
    ),
  },
  {
    title: "How to Assess for Benefits",
    altTitle: "How to Assess for Benefits",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Usually works between 30 min to 2 hours",
            "Reduces allergy symptoms",
          ]}
        />
      </div>
    ),
  },
  {
    title: "How to Manage Side Effects",
    altTitle: "How to Manage Side Effects",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <p className="text-teal-300 font-semibold text-body-md">
          Monitor for drowsiness; if drowsy:
        </p>
        <EducationUl
          type={type}
          descriptionPoints={[
            "Take the medication at bedtime",
            "Consult your pharmacist to switch to a less drowsy medication ",
          ]}
        />
      </div>
    ),
  },
];

export const salineNasalRinsesData = [
  {
    title: "How Medication Works? ",
    altTitle: "How Medication Works? ",

    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Provides relief from congestion",
            "Washes out nasal mucus and allergens",
            "Adds moisture & relieves dryness",
            "Helps to prevent nosebleeds",
          ]}
        />
      </div>
    ),
    type: "ul",
  },
  {
    title: "How to Use the Medication",
    altTitle: "How to Use the Medication",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationOl
          type={type}
          descriptionPoints={[
            "Squeeze the saline solution slowly into one nostril at a time",
            "Allow the solution to pour out the other nostril",
            "Breathe through your mouth not your nose",
            "Use only distilled, boiled, or cooled water",
            "System must be cleaned often",
          ]}
        />
      </div>
    ),
    type: "ol",
  },
  {
    title: "How to Assess for Benefits",
    altTitle: "How to Assess for Benefits",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Less nasal stuffiness",
            "Feels easier to breathe",
            "Less congestion",
            "Mucus is easier to remove from the nose ",
          ]}
        />
      </div>
    ),
    type: "ul",
  },
  {
    title: "How to Manage Side Effects",
    altTitle: "How to Manage Side Effects",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <p className="text-teal-300 font-semibold text-body-md">
          Mild Nasal Irritation:{" "}
        </p>
        <EducationUl
          type={type}
          descriptionPoints={[
            "Change the temperature of the water",
            "Use less Nasal Rinse Solution with the water",
          ]}
        />
      </div>
    ),
    type: "ul",
  },
];

export const intranasalCombinationData = [
  {
    title: "How Medication Works? ",
    altTitle: "How Medication Works? ",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <p className="text-teal-300 font-semibold text-body-md">
          Relieves 4 Symptoms:{" "}
        </p>
        <EducationUl
          type={type}
          descriptionPoints={[
            "Nasal itching",
            "Nasal congestion",
            "Runny nose",
            "Sneezing",
            "Itchy and watery eyes ",
          ]}
        />
      </div>
    ),
    type: "ul",
  },
  {
    title: "How to Use the Medication",
    altTitle: "How to Use the Medication",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationOl
          type={type}
          descriptionPoints={[
            "Use saline spray to clear your nose",
            "Blow your nose to clear your nostrils ",
            "Shake and prime the bottle if new or has not been used for more than 7 days",
            "Aim the spray away from the nasal septum",
            "Spray the medicine into one nostril at a time",
          ]}
        />
      </div>
    ),
    type: "ol",
  },
  {
    title: "How to Assess for Benefits",
    altTitle: "How to Assess for Benefits",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Symptom relief of symptoms occurs within 30-45 minutes",
            "Full benefits depend on regular use",
          ]}
        />
      </div>
    ),
    type: "ul",
  },
  {
    title: "How to Manage Side Effects",
    altTitle: "How to Manage Side Effects",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-6">
        <div className="flex flex-col space-y-2">
          <p className="text-teal-300 font-semibold text-body-md">
            Possible side effects:{" "}
          </p>
          <EducationUl
            type={type}
            descriptionPoints={["nasal irritation, stinging, nose bleeds"]}
          />
        </div>
        <div className="flex flex-col space-y-2">
          <p className="text-teal-300 font-semibold text-body-md">
            Manage nasal irritation by:{" "}
          </p>
          <EducationUl
            type={type}
            descriptionPoints={[
              "Trying a different nasal spray or use a moisturizing nasal gel",
            ]}
          />
        </div>
        <div className="flex flex-col space-y-2">
          <p className="text-teal-300 font-semibold text-body-md">
            Manage nosebleeds by:
          </p>
          <EducationUl
            type={type}
            descriptionPoints={[
              "Directing spray away from septum or use a moisturizing nasal gel",
            ]}
          />
        </div>
      </div>
    ),
    type: "ul",
  },
];

export const nasalLubricantsData = [
  {
    title: "How Medication Works? ",
    altTitle: "How Medication Works? ",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Reduces irritation",
            "Relieves dryness",
            "Helps to moisturize and lubricate nasal passages",
          ]}
        />
      </div>
    ),
  },
  {
    title: "How to Use the Medication",
    altTitle: "How to Use the Medication",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationOl
          type={type}
          descriptionPoints={["Apply a small amount of gel into each nostril"]}
        />
      </div>
    ),
  },
  {
    title: "How to Assess for Benefits",
    altTitle: "How to Assess for Benefits",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl
          type={type}
          descriptionPoints={[
            "Less dryness and irritation",
            "Soothes nasal passages",
          ]}
        />
      </div>
    ),
  },
  {
    title: "How to Manage Side Effects",
    altTitle: "How to Manage Side Effects",
    descriptionPoints: (type) => (
      <div className="flex flex-col space-y-3">
        <EducationUl type={type} descriptionPoints={["Use it sparingly"]} />
      </div>
    ),
  },
];

export const oralDecongestantsData = [];

export const intranasalDecongestantsData = [];

export const tabs = [
  {
    name: "nasalSalineRinse",
    label: "Nasal Saline Rinse",
    type: "orange",
  },
  {
    name: "nasalSalineSpray",
    label: "Nasal Saline Spray",
    type: "orange",
  },
  {
    name: "nasalDrops",
    label: "Nasal Saline Drops",
    type: "orange",
  },
  {
    name: "oralAntihistamines",
    label: "Oral Antihistamines",
    type: "teal",
  },
  {
    name: "intranasalCorticosteroids",
    label: "Intranasal Corticosteroids",
    type: "green",
  },
  {
    name: "nasalLubricants",
    label: "Nasal Lubricant",
    type: "orange",
  },
  {
    name: "intranasalCombination",
    label: "Intranasal Corticosteroid / Antihistamine",
    type: "green",
  },
  {
    name: "addOnOralAntihistamines",
    label: "Oral Antihistamines",
    type: 'pink',
    isAddOn: true,
  },
];

export const getCardColor = (type) => {
  switch(type) {
    case "pink": 
      return "bg-[#ed2a6423]";
    case "orange": 
      return "bg-[#f4802d42]";
    case "green": 
      return "bg-green-100";
    case "teal": 
      return "bg-teal-75";
    default: 
      return "bg-green-100";
  }
};

export const EducationUITypes = {
  InfoCard: 1,
  CircleCard: 2,
  DrugTable: 3,
  DrugCard: 4,
  Custom: 5,
  CommingSoon: 9,
};

export const GeneralInformationTab = {
  name: "general",
  label: "General Information",
  steps: [
    {
      title: "What to Do if I MISS a DOSE?",
      iconUrl: "gen-info-icon",
      type: EducationUITypes.InfoCard,
      cards: [
        {
          title: "Medications Taken Once a Day",
          points: [
            "If a dose is less than 2 or 3 hours late, take the missed dose.",
            "If HIGH RISK drug, check with your Pharmacist.",
          ],
          color: "border-REELLime",
          bgcolor: "bg-REELLime",
          cardNumber: 1,
          TooltipComp: HighRiskNote,
        },
        {
          title: "Medications Taken More Than Once a Day",
          points: [
            "Take the missed dose, as long as next dose is not DUE within a few hours.",
            "If HIGH RISK drug, check with your Pharmacist.",
          ],
          color: "border-teal-100",
          bgcolor: "bg-teal-100",
          cardNumber: 2,
        },
      ],
    },
    // {
    //   title: "Steps After Missing a Dose",
    //   stepIndex: 1,
    //   iconUrl: "gen-info-icon",
    //   type: EducationUITypes.InfoCard,
    //   cards: [
    //     {
    //       cardIndex: 0,
    //       title: "Medications: Once or Twice Daily",
    //       points: [
    //         "Take the missed dose as soon as remembered (as long as the next dose is not due within a few hours)",
    //         "Then continue taking the medicine at the usual times",
    //       ],
    //       color: "border-green-200",
    //       bgcolor: "bg-green-200",
    //       cardNumber: 3,
    //     },
    //     {
    //       cardIndex: 1,
    //       title: "Medications: More than Twice a Day",
    //       points: [
    //         "Skip the missed dose; wait until the next dose is due",
    //         "Then continue taking the medicine at the usual times",
    //       ],
    //       color: "border-REELTeal",
    //       bgcolor: "bg-REELTeal",
    //       cardNumber: 4,
    //     },
    //   ],
    // },
    // {
    //   title: "Where to Store the Medication",
    //   stepIndex: 1,
    //   iconUrl: "gen-info-icon-2",
    //   type: EducationUITypes.InfoCard,
    //   cards: [
    //     {
    //       cardIndex: 0,
    //       title: "General Storage Guidelines",
    //       points: [
    //         "Store in a cool, dry place",
    //         "Keep away from sunlight",
    //         "Keep out of reach of children and pets",
    //       ],
    //       color: "border-REELLime",
    //       bgcolor: "bg-REELLime",
    //       cardNumber: 1,
    //     },
    //     {
    //       cardIndex: 1,
    //       title: "Container and Packaging Tips",
    //       points: [
    //         "Keep medication in original containers/ packaging",
    //         "If using a pill organizer, suggest to have a blister pack prepared by your pharmacy to avoid mistakes",
    //       ],
    //       color: "border-teal-100",
    //       bgcolor: "bg-teal-100",
    //       cardNumber: 2,
    //     },
    //   ],
    // },
  ],
};

export const BloodPressureTab = {
  name: "bloodPressure",
  label: "Blood Pressure",
  steps: [
    {
      name: "bloodPressureTips",
      title: "Blood Pressure Tips",
      iconUrl: "bp-icon",
      type: EducationUITypes.Custom,
    },
    {
      name: "bloodPressureManage",
      title: "Blood Pressure Monitoring",
      iconUrl: "bp-icon-2",
      type: EducationUITypes.Custom,
    },
    {
      name: "bloodPressureManage",
      title: "Manage Blood Pressure",
      iconUrl: "bp-icon-2",
      type: EducationUITypes.Custom,
    },
    {
      name: "bloodPressureClasses",
      title: "Types of Blood Pressure Medications",
      iconUrl: "",
      type: EducationUITypes.DrugTable,
    },
    {
      name: "bloodPressureTable",
      title: "How to Treat Blood Pressure",
      iconUrl: "bp-icon-3",
      type: EducationUITypes.DrugCard,
    },
  ],
};

export const RecreationDrugCard = {
  title: "Recreational Drugs",
  points: [
    "Can INCREASE RISK for stroke and heart disease",
    "amphetamines, marijuana, cocaine, cstasy (MDMA), opioids, LSD (lysergic acid diethylamide), PCP (phencyclidine)",
  ],
};

export const AlcoholCard = {
  title: "Alcohol",
  points: [
    "Too much of any type of alcohol can INCREASE blood pressure",
    "Alcohol can also INCREASE RISK for heart disease and stroke",
  ],
};

export const SmokingPage = {
  name: "smoking",
  title: "Lifestyle Management - Smoking",
  iconUrl: "lifestyle-icon-2",
  type: EducationUITypes.CircleCard,
  cards: [
    {
      title: "Stop Smoking",
      points: [
        "Smoking increase the risk of blood clots",
        "Smoking reduces the amount of oxygen in your blood",
        "Smoking makes your heart work harder.",
      ],
    },
    // {
    //   title: "Ready to Quit?",
    //   points: [],
    //   content: (
    //     <>
    //       <li>As soon as you quit, it REDUCESthe risk of heart attack and stroke</li>
    //       <li>
    //         Click{" "}
    //         <a href="" className="underline">
    //           here
    //         </a>{" "}
    //         to book Smoking Cessation Service
    //       </li>
    //     </>
    //   ),
    // },
  ],
};

export const RecreationalDrugAlcoholPage = {
  title: "Lifestyle Management - Alcohol and Recreational Drugs",
  iconUrl: "lifestyle-icon-4",
  type: EducationUITypes.CircleCard,
  cards: [],
};

export const LifeStyleTab = {
  name: "lifestyle",
  label: "Lifestyle",
  steps: [
    {
      name: "exercise",
      title: "Lifestyle Management - Exercise & Diet",
      iconUrl: "lifestyle-icon",
      type: EducationUITypes.CircleCard,
      cards: [
        {
          title: "Exercise",
          points: [
            "Helps to LOWER blood pressure",
            "Improves brain and body health",
            "Improve sleep",
            "Helps to reduce stress",
            "May IMPROVE cholesterol",
            "New to exercise? Check with your doctor before starting",
          ],
        },
        {
          title: "Healthy Diet",
          points: [
            "Helps to LOWER cholesterol",
            "Helps to LOWER blood pressure",
            "Helps to keep your weight at a healthy level",
            "Helps to control blood sugar",
            "Helps to LOWER risk of heart disease and stroke",
          ],
          iconUrl: "lifestyle-icon-3", //"lifestyle-info-icon-2",
        },
      ],
    },
  ],
};

export const CholesterolTab = {
  name: "Cholesterol",
  label: "Cholesterol",
  steps: [
    {
      name: "cholesterolInfo",
      title: "What is cholesterol?",
      iconUrl: "cholesterol-icon",
      type: EducationUITypes.Custom,
    },
    {
      name: "cholesterolWarnings",
      title: "Cholesterol Tips",
      iconUrl: "cholesterol-icon",
      type: EducationUITypes.Custom,
    },
    {
      name: "cholesterolTypes",
      title: "Types of Cholesterol",
      iconUrl: "cholesterol-icon",
      type: EducationUITypes.Custom,
    },
    // {
    //   name: "cholesterolManage",
    //   title: "Manage Cholesterol",
    //   iconUrl: "cholesterol-icon",
    //   type: EducationUITypes.Custom,
    // },
    {
      name: "cholesterolDrugs",
      title: "Cholesterol Medications",
      iconUrl: "cholesterol-icon",
      type: EducationUITypes.DrugTable,
    },
    {
      name: "cholesterolCards",
      title: "How to Treat Cholesterol",
      iconUrl: "cholesterol-rx",
      type: EducationUITypes.DrugCard,
    },
  ],
};

export const DiabetesTab = {
  name: "Diabetes",
  label: "Diabetes",
  steps: [
    {
      name: "diabetes",
      title: "Diabetes tab coming soon.",
      iconUrl: null,
      type: EducationUITypes.CommingSoon,
    },
  ],
};

export const HeartFailureTab = {
  name: "HeartFailure",
  label: "Heart Failure",
  steps: [
    {
      name: "heartFailure",
      title: "Heart Failure tab coming soon.",
      iconUrl: null,
      type: EducationUITypes.CommingSoon,
    },
  ],
};

export const AsthmaTab = {
  name: "Asthma",
  label: "Asthma",
  steps: [
    {
      name: "asthma",
      title: "Asthma tab coming soon.",
      iconUrl: null,
      type: EducationUITypes.CommingSoon,
    },
  ],
};

export const ConditionReasons = {
  bloodPressure: ["blood pressure", "hypertension", "high blood pressure"],
  cholesterol: [
    "cholesterol",
    "high cholesterol",
    "hypercholesterolemia",
    "hyperlipidemia",
    "hypertriglyceridemia",
    "dyslipidemia",
  ],
  diabetes: [
    "diabetes",
    "diabetes type 1",
    "diabetes type 2",
    "hyperglycemia",
    "high blood sugar",
  ],
  heartFailure: [],
  asthama: [],
};

export const MedicationClasses = [
  {
    className: "Diuretics",
    worksIn: "KIDNEYs",
    description:
      'Helps your body get rid of extra salt and water by making you pee more.\nThis lowers blood pressure. Often called “water pills.”',
    options: [
      {
        value: "chlorthalidone (Hygroton)",
        label: "chlorthalidone (Hygroton)",
      },
      {
        value: "hydrochlorothiazide (Hydrodiuril)",
        label: "hydrochlorothiazide (Hydrodiuril)",
      },
      { value: "indapamide (Lozide)", label: "indapamide (Lozide)" },
      { value: "metolazone (Zaroxolyn)", label: "metolazone (Zaroxolyn)" },
      { value: "bumetanide (Burinex)", label: "bumetanide (Burinex)" },
      {
        value: "ethacrynic Acid (Edecrin)",
        label: "ethacrynic Acid (Edecrin)",
      },
      { value: "furosemide (Lasix)", label: "furosemide (Lasix)" },
      { value: "amiloride (Midamor)", label: "amiloride (Midamor)" },
      { value: "eplerenone (Inspra)", label: "eplerenone (Inspra)" },
      {
        value: "spironolactone (Aldactone)",
        label: "spironolactone (Aldactone)",
      },
      { value: "triamterene (Dyazide)", label: "triamterene (Dyazide)" },
      { value: "acetazolamide (Diamox)", label: "acetazolamide (Diamox)" },
    ],
  },
  {
    className: "ACE Inhibitors",
    worksIn: "KIDNEYs",
    TooltipComp: AceInhibitorsNote,
    description:
      "Blocks an enzyme that causes blood vessels to narrow.\nThis helps the vessels relax and lowers blood pressure.",
    options: [
      { value: "benazepril (Lotensin)", label: "benazepril (Lotensin)" },
      { value: "captopril (Capoten)", label: "captopril (Capoten)" },
      { value: "cilazapril (Inhibace)", label: "cilazapril (Inhibace)" },
      { value: "enalapril (Vasotec)", label: "enalapril (Vasotec)" },
      { value: "fosinopril (Monopril)", label: "fosinopril (Monopril)" },
      {
        value: "lisnopril (Prinivil, Zestril)",
        label: "lisnopril (Prinivil, Zestril)",
      },
      { value: "perindopril (Coversyl)", label: "perindopril (Coversyl)" },
      { value: "quinapril (Accupril)", label: "quinapril (Accupril)" },
      { value: "ramipril (Altace)", label: "ramipril (Altace)" },
      { value: "trandolapril (Mavik)", label: "trandolapril (Mavik)" },
    ],
  },
  {
    className: "Angiotensin Receptor Blockers",
    worksIn: "KIDNEYs",
    TooltipComp: AngiotensionInhibitorsNote,
    description:
      "Blocks the action of a chemical that makes blood vessels tighten.\nThis helps them relax and lowers blood pressure.",
    options: [
      { value: "azilsartan (Edarbi)", label: "azilsartan (Edarbi)" },
      { value: "candesartan (Atacand)", label: "candesartan (Atacand)" },
      { value: "irbesartan (Avapro)", label: "irbesartan (Avapro)" },
      { value: "losartan (Cozaar)", label: "losartan (Cozaar)" },
      { value: "olmesartan (olmetec)", label: "olmesartan (olmetec)" },
      { value: "telmisartan (Micardis)", label: "telmisartan (Micardis)" },
      { value: "valsartan (Diovan)", label: "valsartan (Diovan)" },
    ],
  },
  {
    className: "Calcium Channel Blockers",
    worksIn: "HEART CELLS & BLOOD VESSELS",
    TooltipComp: CalciumChannelBlockersNote,
    description:
      "Prevents Calcium from entering certain cells.\nThis helps the blood vessels relax and widen, which lowers blood pressure.",
    options: [
      { value: "amlodipine (Norvasc)", label: "amlodipine (Norvasc)" },
      { value: "clevidipine (Cleviprex)", label: "clevidipine (Cleviprex)" },
      { value: "felodipine (Plendil)", label: "felodipine (Plendil)" },
      { value: "nifedipine (Adalat)", label: "nifedipine (Adalat)" },
      {
        value: "nifedipine XL (Adalat XL)",
        label: "nifedipine XL (Adalat XL)",
      },
      { value: "diltiazem (Cardizem)", label: "diltiazem (Cardizem)" },
      {
        value: "diltiazem CD (Cardizem CD)",
        label: "diltiazem CD (Cardizem CD)",
      },
      { value: "diltiazem HCL (Tiazac)", label: "diltiazem HCL (Tiazac)" },
      { value: "diltiazem XC (Tiazac XC)", label: "diltiazem XC (Tiazac XC)" },
      { value: "verapamil (Isoptin)", label: "verapamil (Isoptin)" },
      {
        value: "verapamil SR (Isoptin SR, Verelan)",
        label: "verapamil SR (Isoptin SR, Verelan)",
      },
    ],
  },
  {
    className: "Beta Blockers",
    worksIn: "HEART & BLOOD VESSELS",
    TooltipComp: BetaBlockerNote,
    description:
      "Blocks the effects of adrenaline.\nThis makes the heart beat slower and with less force, which lowers blood pressure.",
    options: [
      {
        value: "acebutolol (Monitan, Sectral)",
        label: "acebutolol (Monitan, Sectral)",
      },
      { value: "atenolol (Tenormin)", label: "atenolol (Tenormin)" },
      { value: "bisoprolol (Monocor)", label: "bisoprolol (Monocor)" },
      { value: "carvedilol (Coreg)", label: "carvedilol (Coreg)" },
      { value: "esmolol (Brevibloc)", label: "esmolol (Brevibloc)" },
      { value: "labetalol (Trandate)", label: "labetalol (Trandate)" },
      { value: "metoprolol (Lopresor)", label: "metoprolol (Lopresor)" },
      { value: "nadolol (Corgard)", label: "nadolol (Corgard)" },
      { value: "nebivolol (Bystolic)", label: "nebivolol (Bystolic)" },
      { value: "pindolol (Visken)", label: "pindolol (Visken)" },
      { value: "propranolol (Inderal)", label: "propranolol (Inderal)" },
      { value: "sotalol (Sotacor)", label: "sotalol (Sotacor)" },
      { value: "timolol (Blocadren)", label: "timolol (Blocadren)" },
    ],
  },
  {
    className: "Alpha Blockers",
    worksIn: "BLOOD VESSELS",
    description:
      "Helps keep blood vessels relaxed, which improves blood flow and lowers blood pressure.",
    options: [
      { value: "doxazocin (Cardura)", label: "doxazocin (Cardura)" },
      { value: "prazocin (Minipress)", label: "prazocin (Minipress)" },
      { value: "terazocin (Hytrin)", label: "terazocin (Hytrin)" },
    ],
  },
  {
    className: "Vasodilators",
    worksIn: "BLOOD VESSELS",
    TooltipComp: VasodilatorsNote,
    description:
      "Helps to open the blood vessels and improve blood flow.\nThis helps lower blood pressure.",
    options: [
      {
        value: "isosorbide dinitrate (Isordil sublingual)",
        label: "isosorbide dinitrate (Isordil sublingual)",
      },
      {
        value: "isosorbide dinitrate (Isordil tablet)",
        label: "isosorbide dinitrate (Isordil tablet)",
      },
      {
        value: "isosorbide mononitrate (Imdur long acting)",
        label: "isosorbide mononitrate (Imdur long acting)",
      },
      {
        value: "nitroglycerin (Nitrostat Sublingual)",
        label: "nitroglycerin (Nitrostat Sublingual)",
      },
      {
        value: "nitroglycerin (Nitro-Dur patch)",
        label: "nitroglycerin (Nitro-Dur patch)",
      },
      {
        value: "nitroglycerin (Nitrolingual aerosol)",
        label: "nitroglycerin (Nitrolingual aerosol)",
      },
    ],
  },
  {
    className: "Statins",
    worksIn: "LIVER",
    description:
      "Most effective in lowering LDL cholesterol.May increase HDL cholesterol.\nCan lower triglyceride levels.",
    options: [
      { value: "Atorvastatin (Lipitor)", label: "Atorvastatin (Lipitor)" },
      { value: "Rosuvastatin (Crestor)", label: "Rosuvastatin (Crestor)" },
      { value: "Simvastatin (Zocor)", label: "Simvastatin (Zocor)" },
      { value: "Pravastatin (Pravachol)", label: "Pravastatin (Pravachol)" },
      { value: "Fluvastatin (Lescol)", label: "Fluvastatin (Lescol)" },
      { value: "Lovastatin (Mevacor)", label: "Lovastatin (Mevacor)" },
    ],
  },
  {
    className: "Cholesterol Absorption Blockers",
    worksIn: "INTESTINES",
    description: "Decreases cholesterol absorption.Lowers LDL (\"bad\") cholesterol.May lower TRIGLYCERIDES levels.\nOften added with statin therapy.",
    options: [
      { value: "Ezetimibe (Ezetrol)", label: "Ezetimibe (Ezetrol)" },
    ],
  },
  {
    className: "Bile Acid Binders",
    worksIn: "INTESTINES",
    description: "Lowers LDL (\"bad\") cholesterol.\nCan slightly increase HDL (\"good\") cholesterol",
    options: [
      { value: "Colestyramine", label: "Colestyramine" },
      { value: "Colestipol", label: "Colestipol" },
      { value: "Colesevelam (Lodalis)", label: "Colesevelam (Lodalis)" },
    ],
  },
  {
    className: "Fibrates",
    worksIn: "LIVER",
    description: "Lowers TRIGLYCERIDE levels.\nIncreases HDL cholesterol (\"good\").\nMay lower or have no effect on LDL cholesterol.",
    options: [
      { value: "Fenofibrate", label: "Fenofibrate" },
      { value: "Bezafibrate", label: "Bezafibrate" },
      { value: "Gemfibrozil", label: "Gemfibrozil" },
    ],
  },
  {
    className: "Niacin (Form of Vitamin B)",
    worksIn: "LIVER",
    description: "Increases HDL cholesterol.\nHas a small effect on loweringTRIGLYCERIDE levels and LDL (\"bad\") cholesterol.",
    options: [
      { value: "Niacin / nicotinic acid", label: "Niacin / nicotinic acid" },
    ],
  },
  {
    className: "PCSK9 Inhibitors",
    worksIn: "LIVER",
    description: "Lowers LDL (\"bad\") cholesterol.Help the liver remove the \"bad\" cholesterol from the blood.\nUsed if unable to reach LDL goals.",
    options: [
      { value: "Alirocumab (Praluent)", label: "Alirocumab (Praluent)" },
      { value: "Evolocumab (Repatha)", label: "Evolocumab (Repatha)" },
    ],
  },
];

export const SignsOfBloodPressure = [
  "Sometimes there are NO warning signs",
  "Severe headaches, dizziness",
  "Chest pain, difficulty breathing",
  "Nausea and vomiting",
  "Blurred vision",
];

export const MultidrugTherapy = [
  "How high is the blood pressure number",
  "If blood pressure targets are not achieved",
  "If other chronic conditions co-exist",
];

export const notificationMethodOptions = [
  { value: "emailOrFax", label: "Email-Fax", disabled: true },
  { value: "email", label: "Email" },
  { value: "fax", label: "Fax" },
  { value: "inperson", label: "In person" },
  { value: "phone", label: "Phone" },
  { value: "other", label: "Other" },
];

export const sameAppointmentDateCheckBoxOptions = [
  { value: "sameAppointmentDate", label: "Select to set same appointment date" },
];

export const AMRReferralTypeOptions = [
  { value: "No Referral", label: "No Referral" },
  { value: "Dentist", label: "Dentist" },
  { value: "Dietician", label: "Dietician" },
  { value: "Internal", label: "Internal Medicine" },
  { value: "Neurology", label: "Neurology" },
  { value: "Nurse", label: "Nurse" },
  { value: "Nurse Practitioner", label: "Nurse Practitioner" },
  { value: "Optometrist", label: "Optometrist" },
  { value: "Pharmacist", label: "Pharmacist" },
  { value: "Primary Provider", label: "Primary Provider/Physician" },
  { value: "Physiotherapist", label: "Physiotherapist" },
  { value: "Podiatrist", label: "Podiatrist" },
  { value: "Psychologist", label: "Psychologist" },
  { value: "Respiratory", label: "Respiratory therapist" },
];

export const referralTypeCard = {
  question: "Select and Confirm Referral Type:",
  options: [
    { value: "No Referral", label: "No Referral" },
    {
      label: "Primary Provider",
      value: "Primary Provider",
    },
    {
      label: "Other Healthcare Provider",
      value: "Other Healthcare Provider",
    },
    {
      label: "Nurse",
      value: "Nurse",
    },
    {
      label: "Nurse Practitioner",
      value: "Nurse Practitioner",
    },
    {
      label: "Walk In Clinic - No Primary Provider",
      value: "Walk In Clinic - No Primary Provider",
    },
    {
      label: "Emergency - No Primary Provider",
      value: "Emergency - No Primary Provider",
    },
  ],
};

export const notificationTypeOptions = [
  {
    value: "same",
    label: "Same as Referral Type",
  },
  {
    value: "nonApplicable",
    label: "Non-Applicable",
  },
  {
    label: "Primary Provider",
    value: "Primary Provider",
  },
  {
    label: "Nurse",
    value: "Nurse",
  },
  {
    label: "Nurse Practitioner",
    value: "Nurse Practitioner",
  },
  {
    label: "Walk In Clinic - No Primary Provider",
    value: "Walk In Clinic - No Primary Provider",
  },
  {
    label: "Emergency - No Primary Provider",
    value: "Emergency - No Primary Provider",
  },
  {
    label: "Other Healthcare Provider",
    value: "Other Healthcare Provider",
  },
];

export const AMRNotificationTypeOptions = [
  { value: "same", label: "Same as Referral Type" },
  { value: "nonApplicable", label: "Non-Applicable" },
  ...AMRReferralTypeOptions.filter((option) => option.value !== "No Referral"),
];

export const pharmacyLocationOptions = [
  { value: "current", label: "Current Pharmacy" },
  { value: "alternate", label: "Alternate Pharmacy" }
];

export const designationOptions = [
  { value: "allergist", label: "Allergist/ Immunologist" },
  { value: "cardiologist", label: "Cardiologist" },
  { value: "dermatologist", label: "Dermatologist" },
  { value: "endocrinologist", label: "Endocrinologist" },
  { value: "family_medicine", label: "Family Medicine" },
  { value: "geriatric_medicine", label: "Geriatric Medicine" },
  { value: "nephrologist", label: "Nephrologist" },
  { value: "neurologist", label: "Neurologist" },
  { value: "nurse_practitioner", label: "Nurse Practitioner" },
  { value: "oncologist", label: "Oncologist" },
  { value: "pediatrician", label: "Pediatrician" },
  { value: "psychologist", label: "Psychologist" },
  { value: "psychiatrist", label: "Psychiatrist" },
  { value: "respirologist", label: "Respirologist" },
  { value: "surgeon", label: "Surgeon" },
  { value: "urologist", label: "Urologist" },
  { value: "podiatrist", label: "Podiatrist" },
  { value: "dietitian", label: "Dietitian" },
  { value: "chiropractor", label: "Chiropractor" },
  { value: "physio_therapy", label: "Physio Therapy" },
];

export const ARBillingOptions = [
  { value: "selectBilling", label: "Select Billing Information" },
  {
    value: "PIIP",
    label: (
      <span>
        Prescription Issued In Person <span className="text-teal-300">PIN 9858181</span>
      </span>
    ),
    info: "Prescription Issued In Person",
    pin: "9858181"
  },
  {
    value: "NPIIP",
    label: (
      <span>
        No Prescription Issued In Person <span className="text-teal-300">PIN 9858182</span>
      </span>
    ),
    info: "No Prescription Issued In Person",
    pin: "9858182"
  },
  {
    value: "PIV",
    label: (
      <span>
        Prescription Issued Virtual <span className="text-teal-300">PIN 9858183</span>
      </span>
    ),
    info: "Prescription Issued Virtual",
    pin: "9858183"
  },
  {
    value: "NPIV",
    label: (
      <span>
        No Prescription Issued Virtual <span className="text-teal-300">PIN 9858184</span>
      </span>
    ),
    info: "No Prescription Issued Virtual",
    pin: "9858184"
  },
];

export const AMRBillingOptions = [
  { value: "selectBilling", label: "Select Billing Information" },
  {
    value: "amrReviewPIN",
    label: (
      <span>
        Annual Medication Review <span className="text-teal-300">{"   "}PIN 93899979</span>
      </span>
    ),
  },
];

export const reasonStartOptions = [
  { value: "Refused", label: "No Follow Up - Patient Declined" },
  { value: "NotSpecified", label: "No Follow Up - Not Specified" },
  { value: "Other", label: "No Follow Up - Other" },
  { value: "PharmacyBooking", label: "Using Pharmacy's Booking System"},
];

export const followUpTopicOptions = [
  { value: "nofollowup", label: "No Follow Up" },
  { value: "bloodPressure", label: "Blood Pressure" },
  { value: "cholesterol", label: "Cholesterol" },
  { value: "compliancePackaging", label: "Compliance Packaging" },
  { value: "diabetes", label: "Diabetes" },
  { value: "heartFailure", label: "Heart Failure" },
  { value: "medicationAdherence", label: "Medication Adherence" },
  { value: "respiratoryHealth", label: "Respiratory Health" },
  { value: "pharmacySystem", label: "Use Pharmacy Organization's Booking System" },
  { value: "vaccineHealth", label: "Vaccine Health" },
  { value: "Other", label: "Other" },
];

export const CholesterolMedicationClasses = MedicationClasses.filter((mc) =>
  [
    "Statins",
    "Cholesterol Absorption Blockers",
    "Bile Acid Binders",
    "Fibrates",
    "Niacin (Form of Vitamin B)",
    "PCSK9 Inhibitors",
  ].includes(mc.className)
);

export const BloodPressureMedicationClasses = MedicationClasses.filter((mc) =>
  [
    "Diuretics",
    "ACE Inhibitors",
    "Angiotensin Receptor Blockers",
    "Calcium Channel Blockers",
    "Beta Blockers",
    "Alpha Blockers",
    "Vasodilators",
  ].includes(mc.className)
);